import {
  FormValidator,
  type FormValidatorConfig,
  type FormValidatorContext,
  type FormValidatorSettings
} from '@common';
import { toRaw } from 'vue';
import { isWithinMonths } from '@core';
import { PeriodBoundary } from '../../../models';

export interface SoilTemperaturePeriodDateValidatorSettings extends FormValidatorSettings {
  otherFieldName: string;
  periodBoundary: PeriodBoundary;
  invalidEndDateMessage?: string;
  invalidStartDateMessage?: string;
}

export type SoilTemperaturePeriodDateValidatorConfig = FormValidatorConfig<SoilTemperaturePeriodDateValidatorSettings>;

export class SoilTemperaturePeriodDateValidator extends FormValidator<SoilTemperaturePeriodDateValidatorSettings> {
  constructor() {
    super();
    this._name = 'soilTemperaturePeriodDate';
    this._settings = {
      needTranslate: true,
      otherFieldName: '',
      periodBoundary: PeriodBoundary.START,
      invalidEndDateMessage: 'statistics.form.validator.soilTemperaturePeriodDate.invalidEndDateMessage',
      invalidStartDateMessage: 'statistics.form.validator.soilTemperaturePeriodDate.invalidStartDateMessage',
      invalidMessage: ''
    };
  }

  public override async onValidate(value: any, context: FormValidatorContext) {
    const values = toRaw(context.values);
    const settings = this.settings;
    const otherValue = values[settings.otherFieldName];

    if (!value || !otherValue) {
      this._valid = true;
      return;
    }

    const startDate = settings.periodBoundary === PeriodBoundary.START ? parseDate(value) : parseDate(otherValue);
    const endDate = settings.periodBoundary === PeriodBoundary.START ? parseDate(otherValue) : parseDate(value);

    this._valid = Boolean(startDate && endDate && isWithinMonths(startDate, endDate, 1));

    if (!this._valid) {
      const msg =
        settings.periodBoundary === PeriodBoundary.START
          ? settings.invalidStartDateMessage
          : settings.invalidEndDateMessage;
      this.addMessage(msg ?? '');
    }
  }
}

const parseDate = (value: any) => (value ? new Date(value) : null);
